import { DataBean } from "../DataBean";

export class GenericItem extends DataBean {


    public async deleteAirLine(idAirLine: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteAirLine_Number", [idAirLine]);
    }



}